<mat-spinner *ngIf="isResolverLoading()"></mat-spinner>
<app-client-cards *ngIf="!isResolverLoading()"></app-client-cards>
